import {Command} from 'substance'
import KeybindingEditorComponent from '../components/KeybindingEditorComponent'

class OpenKeybindingEditorCommand extends Command {

    getCommandState() {
        return true
    }

    execute(params) {
        const {api} = params
        api.ui.showDialog(KeybindingEditorComponent, {}, {
            title: api.getLabel('keybinding-keyboard-shortcuts'),
            primary: false,
            secondary: 'Ok',
            takeover: true
        })
    }
}

export default OpenKeybindingEditorCommand
